import 'antd/dist/reset.css';
import { ApolloProvider } from '@apollo/client/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { gtag } from '@guuru/analytics-web';
import { client } from '@guuru/graphql-web';
import { ErrorBoundary } from '@guuru/react-error-pages';
import { initSentry, handleError, Sentry } from '@guuru/sentry-web';
import { COLORS } from '@guuru/theme-common';
import ThemeProvider from '@guuru/theme-web';
import { i18n } from '@guuru/translation-web';
import MainView from '../views/MainView';
import GlobalStyle from './GlobalStyle';

if (process.env.PAGES_GA_MEASUREMENT_ID) {
  gtag.initialize(process.env.PAGES_GA_MEASUREMENT_ID, {
    debug_mode: process.env.ANALYTICS_DEBUG,
  });
  gtag.event('page_view', {
    page_path: window.location.pathname + window.location.search,
  });
}

if (process.env.PAGES_SENTRY_DSN) {
  initSentry(process.env.PAGES_SENTRY_DSN);
}

const PagesApp = Sentry.withProfiler(() => (
  <ApolloProvider client={client}>
    <ThemeProvider theme={{ color: COLORS.primaryColor }}>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary>
          <GlobalStyle />
          <MainView />
        </ErrorBoundary>
      </I18nextProvider>
    </ThemeProvider>
  </ApolloProvider>
));

const container = document.getElementById('app');

if (!container) {
  throw new Error('Missing app root element');
}

const root = createRoot(container, {
  onCaughtError: handleError,
  onRecoverableError: handleError,
  onUncaughtError: handleError,
});
root.render(<PagesApp />);
